<template>
  <div class="wrapper">
    <div
      class="milt-select-widget"
      ref="milt_select_widget"
      @click="shop_pop_up = !shop_pop_up"
    >
      <label>{{ selected_items.length | validate }} Categories selected</label>
      <img src="@/assets/admin-icon/allow-down.svg" />
    </div>
    <div
      class="select-items-widget"
      v-if="shop_pop_up"
      v-closable="{
        exclude: ['milt_select_widget'],
        handler: 'hidePopUp',
      }"
    >
      <div class="select-item">
        <input type="checkbox" @change="selectAll" value="All" id="_all" />
        <label for="_all">All</label>
      </div>
      <div class="select-item" v-for="(item, index) in input_data" :key="index">
        <input
          type="checkbox"
          @change="onChange"
          :value="item"
          :id="`id_${item}`"
          :checked="selected_items.includes(item)"
        />
        <label :for="`id_${item}`">{{ item | validate }}</label>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "milt-select-widget",
  props: {
    content: {
      type: Array,
      default: function () {
        return [];
      },
    },
    value: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      input_data: [],
      selected_items: [],
      shop_pop_up: false,
    };
  },
  computed: {},
  watch: {
    content(val) {
      let vm = this;
      vm.input_data = val;
    },
    value(val) {
      let vm = this;
      vm.selected_items = val;
    },
  },
  mounted() {
    let vm = this;
    vm.input_data = vm.content;
    if (vm.value) {
      vm.selected_items = vm.value;
    }
  },
  methods: {
    hidePopUp() {
      let vm = this;
      vm.shop_pop_up = false;
    },
    onChange({ target }) {
      let vm = this;
      if (target.checked) {
        vm.selected_items.push(target.value);
      } else {
        const index = vm.selected_items.indexOf(target.value);
        if (index > -1) {
          vm.selected_items.splice(index, 1);
        }
      }
      vm.$emit("onSubmit", vm.selected_items);
      vm.$emit("input", vm.selected_items);
    },
    selectAll({ target }) {
      let vm = this;
      if (target.checked) {
        vm.selected_items = vm.input_data;
      } else {
        vm.selected_items = [];
      }
      vm.$emit("onSubmit", vm.selected_items);
      vm.$emit("input", vm.selected_items);
    },
  },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";
.wrapper {
  position: relative;
  width: 250px;
  border-radius: 5px;
  .milt-select-widget {
    display: flex;
    border: 1px solid #ddd;
    border-radius: 5px;
    width: 100%;
    height: 45px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 20px;
  }
  .select-items-widget {
    position: absolute;
    top: 50px;
    left: 0px;
    right: 0px;
    background: #ffffff;
    border: 1px solid #f2f4f8;
    box-sizing: border-box;
    border-radius: 5px;
    height: 400px;
    overflow-y: auto;
    .select-item {
      border-bottom: 1px solid #f2f4f8;
      padding: 15px 15px;
      display: flex;
      align-items: center;
      label {
        margin-top: 2px;
        margin-left: 7px;
      }
    }
  }
}
</style>